import { ModuleWithProviders, NgModule } from "@angular/core";
import { IssueViewerComponent } from "./components/issue-viewer/issue-viewer.component";
import { IssueCardComponent } from "./components/basic/issue-card/issue-card.component";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IssueManagerRoutingModule } from "./issue-manager-routing.module";
import { CommonModule } from "@angular/common";
import { BreadcrumbComponent } from "../../components/breadcrumb/breadcrumb.component";
import { BrowserModule } from "@angular/platform-browser";
import { IssueDetailsComponent } from "./components/basic/issue-details/issue-details.component";

@NgModule({
  declarations: [IssueCardComponent, IssueViewerComponent, IssueDetailsComponent],
  imports: [NgbModule,IssueManagerRoutingModule, CommonModule],
  exports: [],
})

export class IssueManagerModule {
  static forRoot(): ModuleWithProviders<IssueManagerModule> {
    return {
      ngModule: IssueManagerModule,
      providers: [

      ],
    };
  }
}
